import React, { forwardRef, useState } from 'react';

import '../styles/Input.css';

import { ReactComponent as AssetIconShow } from '../resources/assets/passwordShow.svg'; 
import { ReactComponent as AssetIconHide } from '../resources/assets/passwordHide.svg'; 
import { ReactComponent as AssetIconSearch } from '../resources/assets/iconSearch.svg'; 

const Input = forwardRef(({ value, defaultValue, onChange, placeholder, minLength, maxLength, label, required, error, type = 'text', pattern, onEnter, disabled=false, tabIndex}, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
    if(ref.current) {
      ref.current.focus();
    }  
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter(); 
    }
  };

  return (
    <div className="input-wrapper">
      {label && <label className="input-label">{label}</label>} 
      <input
        ref={ref}
        className="input-normal"
        type={ type==="password" ? (isPasswordVisible ? "text" : "password") : "text" }
        value={value}
        defaultValue={defaultValue}
        minLength={minLength}
        maxLength={maxLength}
        tabIndex={tabIndex}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder={placeholder}
      />
      {error && <div className="input-error">{error}</div>} 

      {type==="password" ? <button className="input-password-icon" onClick={togglePasswordVisibility}>{isPasswordVisible ? <AssetIconHide height={"75%"} /> : <AssetIconShow height={"75%"} />}</button> : "" }
      {type==="search" ? <button className="input-search-icon"><AssetIconSearch height={"75%"} /></button> : "" }
    </div>
  ); 
});

export default Input;